import styled from 'styled-components';

export const DropdownGroup = styled.div`
display: flex;
flex-direction: column;
position: relative;
${({ wide }) => (wide ? 'margin-bottom: 1.8rem;' : '')}
`;

export const StyledLabel = styled.span`
margin-bottom: 1em;
padding-right: 9px;
`;

export const DropdownBody = styled.div`
display: ${({ isOpen }) => (!isOpen ? 'none' : '')};
width: ${({ wide }) => (wide ? '100%' : 'max-content')};
min-width: 80px;
border: 2px solid #DADEDF;
background: #6B6A6A;
border-radius: 6px;
position: absolute;
${({ wide }) => (wide ? 'top: 100%;' : '')}
z-index: 999;
`;
export const DropdownHeader = styled.div`
width: ${({ wide }) => (wide ? '100%' : 'fit-content')};
min-width: 80px;
border: 2px solid #DADEDF;
display: flex;
align-items: center;
padding: ${({ wide }) => (wide ? '.5rem 1rem' : '.5rem')};
border-radius: 6px;
${({ wide }) => (wide ? '' : 'margin-bottom: 1.8rem;')}
cursor: pointer;
`;
export const DropdownItem = styled.div`
font-weight: 600;
font-size: 16px;
line-height: 21px;
color: white;
padding: 8px 12px;
display: flex;
justify-content: center;
${({ wide }) => (wide ? 'align-items: center; justify-content: flex-start;' : '')}
cursor: pointer;
&:hover {
    background-color: #E79762;
}
`;

export const DropdownValue = styled.div`
flex-grow: 1;
padding-left: ${({ wide }) => (wide ? '0' : '1rem')};
`;

export const DropdownIcon = styled.div`
position: absolute;
left: 12px;
`;

export const Required = styled.span`
color: red;
margin-left: 2px;
margin-right: 2px;
`;
